import { Button } from "@bleu.builders/ui";
import { BellRingIcon, XIcon } from "lucide-react";
import React, { useEffect, useState } from "react";

import { ToggleFormAction } from "#/components/ToggleFormAction";
import { useLocalStorage } from "#/contexts/useLocalStorage";

const TooltipContentWithCloseButton = ({ onClose }) => {
  const onButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClose(e);
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="small"
        className="absolute top-0 right-0 -mt-1 -mr-2 hover:bg-background p-0"
        onClick={onButtonClick}
      >
        <XIcon className="size-4 p-0" />
        <span className="sr-only">Close</span>
      </Button>
      <span className="block p-2">
        Ative o sino para receber, por e-mail, todas as atualizações relevantes
        sobre essa tese tributária.
      </span>
    </div>
  );
};

const ToggleReceiveNotificationsAndCount = ({ row }) => {
  // show tooltip only twice based on the day
  const [tooltipShown, setTooltipShown] = useLocalStorage(
    "click-thesisupdate-preference-feature",
    // @ts-ignore-next-line
    { visits: [] },
  );

  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipViewed, setTooltipViewed] = useState(true);

  useEffect(() => {
    if (tooltipShown.visits.length < 2) {
      const currentDate = new Date().toISOString().split("T")[0];
      const alreadyVisited = tooltipShown.visits.includes(currentDate);

      if (!alreadyVisited) {
        setTooltipViewed(false);
        setShowTooltip(true);
        const visits = new Set([...tooltipShown.visits, currentDate]);
        setTooltipShown({
          visits: Array.from(visits),
        });
      }
    } else {
      setTooltipViewed(true);
    }
  }, [tooltipShown, setTooltipShown]);

  const onTooltipClose = (e) => {
    setShowTooltip(false);
    setTooltipViewed(true);
  };

  const tooltipHandlers = tooltipViewed
    ? undefined
    : { open: showTooltip, defaultOpen: showTooltip };

  const tooltipContent = tooltipViewed ? (
    "Ative o sino para receber atualizações relevantes sobre essa tese tributária."
  ) : (
    <TooltipContentWithCloseButton onClose={onTooltipClose} />
  );

  return (
    <ToggleFormAction
      Icon={BellRingIcon}
      tooltip={tooltipContent}
      actionPath={
        row.original.actions.find((r) => r.name == "Notificar").url_path
      }
      allowMutate={false}
      color="gold"
      className="ml-2 border-none fill-muted-foreground/70 stroke-2 stroke-muted-foreground"
      defaultSelected={row.original.notify}
      tooltipHandlers={tooltipHandlers}
    />
  );
};

export const ToggleNotificationPreference = ({
  row,
  index,
  parentRowIndex,
}) => {
  const firstTableItem = index === 0 && parentRowIndex === 0;

  if (firstTableItem) {
    return <ToggleReceiveNotificationsAndCount row={row} />;
  }

  return (
    <ToggleFormAction
      Icon={BellRingIcon}
      tooltip="Ative o sino para receber atualizações relevantes sobre essa tese tributária."
      actionPath={
        row.original.actions.find((r) => r.name == "Notificar").url_path
      }
      allowMutate={false}
      color="gold"
      className="ml-2 border-none fill-muted-foreground/70 stroke-2 stroke-muted-foreground"
      defaultSelected={row.original.notify}
    />
  );
};
